import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth.module";
import session from "./session.module";
import team from "./team.module";
import ecosystem from "./ecosystem.module";
import request from "./request.module";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    session,
    team,
    request,
    ecosystem
  }
});
